import { Divider } from '@mui/material';
import { imageURL } from 'Config/endpoints';
import React from 'react'
import { useQuery } from 'react-query';
import { Link, useParams } from 'react-router-dom';
import { getSellerByIdFn } from 'Services/Seller';

const SellerDetails = () => {
    const { seller_id } = useParams();

    const { data: getSellerByIdResponse } = useQuery({
        queryFn: () => getSellerByIdFn(seller_id),
        queryKey: ['get-seller-id', seller_id],
        enabled: !!seller_id,
        refetchOnWindowFocus: false
    })

    const details = getSellerByIdResponse?.data?.data;
    const ceatedAt = new Date(details?.created_at).toLocaleDateString();

    return (
        <div className='p-4'>
            <div className='bg-white shadow-xl text-black my-4 rounded-lg p-4'>
                <h4 className='font-bold text-lg'>Basic Information</h4>
                <Divider />
                <div className='grid grid-cols-[200px_1fr] mt-4'>
                    <p className='h-32 w-32 rounded-full overflow-hidden border shadow-md'>
                        <img
                            src={imageURL(details?.logo)}
                            alt={details?.company}
                            className='w-full h-full object-cover'
                        />
                    </p>
                    <div className='mt-4 grid grid-cols-4 gap-4'>
                        {details?.company &&
                            <div>
                                <p className='text-xs text-gray-500'>Company Name:</p>
                                <p className='text-base'>{details?.company}</p>
                            </div>
                        }
                        {details?.contact_person &&
                            <div>
                                <p className='text-xs text-gray-500'>Contact Person:</p>
                                <p className='text-base'>{details?.contact_person}</p>
                            </div>
                        }
                        {details?.designation &&
                            <div>
                                <p className='text-xs text-gray-500'>Designation:</p>
                                <p className='text-base'>{details?.designation}</p>
                            </div>
                        }
                        {details?.business_type &&
                            <div>
                                <p className='text-xs text-gray-500'>Business Type:</p>
                                <p className='text-base'>{details?.business_type}</p>
                            </div>
                        }
                        {details?.active_status &&
                            <div>
                                <p className='text-xs text-gray-500'>Business Type:</p>
                                <p className='text-base'>{details?.active_status ? "Enabled" : "Disabled"}</p>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className='grid grid-cols-2 gap-4 my-8'>
                <div className='bg-white shadow-xl text-black rounded-lg p-4'>
                    <h4 className='font-bold text-lg'>Contact Information</h4>
                    <Divider />
                    <div className='mt-4 grid grid-cols-2 gap-4'>
                        {details?.primary_email &&
                            <div>
                                <p className='text-xs text-gray-500'>Primary Email:</p>
                                <p className='text-base'>{details?.primary_email}</p>
                            </div>
                        }
                        {details?.primary_mobile &&
                            <div>
                                <p className='text-xs text-gray-500'>Priamary Mobile:</p>
                                <p className='text-base'>{details?.primary_mobile}</p>
                            </div>
                        }
                        {details?.alternate_mobile &&
                            <div>
                                <p className='text-xs text-gray-500'>Alternate Mobile:</p>
                                <p className='text-base'>{details?.alternate_mobile}</p>
                            </div>
                        }
                        {details?.alternate_email &&
                            <div>
                                <p className='text-xs text-gray-500'>Alternate Email:</p>
                                <p className='text-base'>{details?.alternate_email}</p>
                            </div>
                        }
                        {details?.landline_number &&
                            <div>
                                <p className='text-xs text-gray-500'>Landline Number:</p>
                                <p className='text-base'>{details?.landline_number}</p>
                            </div>
                        }
                        {details?.alternate_landline_number &&
                            <div>
                                <p className='text-xs text-gray-500'>Alternate Landline Number:</p>
                                <p className='text-base'>{details?.alternate_landline_number}</p>
                            </div>
                        }
                    </div>
                </div>
                <div className='bg-white shadow-xl text-black rounded-lg p-4'>
                    <h4 className='font-bold text-lg'>Address Details</h4>
                    <Divider />
                    <div className='mt-4 grid grid-cols-2 gap-4'>
                        {details?.building_no &&
                            <div>
                                <p className='text-xs text-gray-500'>Building Number:</p>
                                <p className='text-base'>{details?.building_no}</p>
                            </div>
                        }
                        {details?.area &&
                            <div>
                                <p className='text-xs text-gray-500'>Area:</p>
                                <p className='text-base'>{details?.area}</p>
                            </div>
                        }
                        {details?.locality &&
                            <div>
                                <p className='text-xs text-gray-500'>Loacality:</p>
                                <p className='text-base'>{details?.locality}</p>
                            </div>
                        }
                        {details?.city &&
                            <div>
                                <p className='text-xs text-gray-500'>City:</p>
                                <p className='text-base'>{details?.city}</p>
                            </div>
                        }
                        {details?.district &&
                            <div>
                                <p className='text-xs text-gray-500'>District:</p>
                                <p className='text-base'>{details?.district}</p>
                            </div>
                        }
                        {details?.state &&
                            <div>
                                <p className='text-xs text-gray-500'>State:</p>
                                <p className='text-base'>{details?.state}</p>
                            </div>
                        }
                        {details?.country &&
                            <div>
                                <p className='text-xs text-gray-500'>Country:</p>
                                <p className='text-base'>{details?.country}</p>
                            </div>
                        }
                        {details?.pincode &&
                            <div>
                                <p className='text-xs text-gray-500'>Pincode:</p>
                                <p className='text-base'>{details?.pincode}</p>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className='bg-white shadow-xl text-black my-8 rounded-lg p-4'>
                <h4 className='font-bold text-lg'>Business Information</h4>
                <Divider />
                <div className='mt-4 grid grid-cols-4 gap-4'>
                    {details?.gst &&
                        <div>
                            <p className='text-xs text-gray-500'>GST:</p>
                            <p className='text-base'>{details?.gst}</p>
                        </div>
                    }
                    {details?.pan &&
                        <div>
                            <p className='text-xs text-gray-500'>PAN:</p>
                            <p className='text-base'>{details?.pan}</p>
                        </div>
                    }
                    {details?.cin &&
                        <div>
                            <p className='text-xs text-gray-500'>CIN:</p>
                            <p className='text-base'>{details?.cin}</p>
                        </div>
                    }
                    {details?.iec &&
                        <div>
                            <p className='text-xs text-gray-500'>IEC:</p>
                            <p className='text-base'>{details?.iec}</p>
                        </div>
                    }
                    {details?.tan &&
                        <div>
                            <p className='text-xs text-gray-500'>TAN:</p>
                            <p className='text-base'>{details?.tan}</p>
                        </div>
                    }
                    {details?.annual_turnover &&
                        <div>
                            <p className='text-xs text-gray-500'>Annual Turnover:</p>
                            <p className='text-base'>{details?.annual_turnover}</p>
                        </div>
                    }
                    {details?.country &&
                        <div>
                            <p className='text-xs text-gray-500'>Number of Employees:</p>
                            <p className='text-base'>{details?.number_of_employee}</p>
                        </div>
                    }
                    {details?.ownership_type &&
                        <div>
                            <p className='text-xs text-gray-500'>Ownership Type:</p>
                            <p className='text-base'>{details?.ownership_type}</p>
                        </div>
                    }
                </div>
            </div>
            <div className='grid grid-cols-2 gap-4  my-8 '>
                <div className='bg-white shadow-xl text-black rounded-lg p-4'>
                    <h4 className='font-bold text-lg'>Online Presence</h4>
                    <Divider />
                    <div className='mt-4 grid grid-cols-2 gap-4'>
                        {details?.website &&
                            <div>
                                <p className='text-xs text-gray-500'>Website:</p>
                                <Link
                                    className='text-base text-green-600 underline'
                                    target='_blank'
                                    to={details?.website}
                                >
                                    Open Link
                                </Link>
                            </div>
                        }
                        {details?.business_url &&
                            <div>
                                <p className='text-xs text-gray-500'>Facebook :</p>
                                <Link
                                    className='text-base text-green-600 underline'
                                    target='_blank'
                                    to={details?.business_url}
                                >
                                    Open Link
                                </Link>
                            </div>
                        }
                        {details?.business_url &&
                            <div>
                                <p className='text-xs text-gray-500'>Instagram :</p>
                                <Link
                                    className='text-base text-green-600 underline'
                                    target='_blank'
                                    to={details?.business_url}
                                >
                                    Open Link
                                </Link>
                            </div>
                        }
                        {details?.business_url &&
                            <div>
                                <p className='text-xs text-gray-500'>Business  :</p>
                                <Link
                                    className='text-base text-green-600 underline'
                                    target='_blank'
                                    to={details?.business_url}
                                >
                                    Open Link
                                </Link>
                            </div>
                        }
                    </div>
                </div>
                <div className='bg-white shadow-xl text-black rounded-lg p-4'>
                    <h4 className='font-bold text-lg'>Catalog</h4>
                    <Divider />
                    <div className='mt-4 grid grid-cols-2 gap-4'>
                        {details?.catalog &&
                            <div>
                                <p className='text-xs text-gray-500'>Catalog:</p>
                                <p className='text-base'>{details?.catalog}</p>
                            </div>
                        }
                        {details?.catlog_url &&
                            <div>
                                <p className='text-xs text-gray-500'>Catalog:</p>
                                <Link className='text-base text-green-600 underline' to={details?.catlog_url}>Open Link</Link>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className='bg-white shadow-xl text-black my-8 rounded-lg p-4'>
                <h4 className='font-bold text-lg'>Additional Media</h4>
                <Divider />
                <div className='mt-4 grid grid-cols-4 gap-4'>
                    {details?.business_card_front &&
                        <div>
                            <p className='text-xs text-gray-500'>Business Card Front:</p>
                            <p className='text-base'>{details?.business_card_front}</p>
                        </div>
                    }
                    {details?.business_card_back &&
                        <div>
                            <p className='text-xs text-gray-500'>Business Card Back:</p>
                            <p className='text-base'>{details?.business_card_back}</p>
                        </div>
                    }
                </div>
            </div>
            <div className='bg-white shadow-xl text-black my-8 rounded-lg p-4'>
                <h4 className='font-bold text-lg'>Miscellaneous</h4>
                <Divider />
                <div className='mt-4 grid grid-cols-4 gap-4'>
                    {details?.ceo_name &&
                        <div>
                            <p className='text-xs text-gray-500'>CEO Name:</p>
                            <p className='text-base'>{details?.ceo_name}</p>
                        </div>
                    }
                    {details?.secondary_business &&
                        <div>
                            <p className='text-xs text-gray-500'>Secondary Business:</p>
                            <p className='text-base'>{details?.secondary_business}</p>
                        </div>
                    }
                    {details?.user &&
                        <div>
                            <p className='text-xs text-gray-500'>User ID:</p>
                            <p className='text-base'>{details?.user}</p>
                        </div>
                    }
                    {details?.created_at &&
                        <div>
                            <p className='text-xs text-gray-500'>Created At:</p>
                            <p className='text-base'>{ceatedAt}</p>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default SellerDetails;